const JSON_HEADERS = { "Content-Type": "application/json" };

class NotesService {
  constructor(client) {
    this.apiClient = client;
  }

  // GET notes/{noteTypeID}/{contextID}?pinned={pinned}
  async getNotes(noteTypeID, contextID, pinned = null) {
    const params = {};
    if (pinned !== null) {
      params.pinned = pinned;
    }
    return this.apiClient.get(`notes/${noteTypeID}/${contextID}`, { params });
  }

  // POST /notes
  async createNote(payload) {
    return this.apiClient.post("notes", payload, { headers: JSON_HEADERS });
  }

  // PUT /notes
  async updateNote(payload) {
    return this.apiClient.put("notes", payload, { headers: JSON_HEADERS });
  }

  // DELETE /notes
  async deleteNote(payload) {
    return this.apiClient.delete("notes", { data: payload, headers: JSON_HEADERS });
  }
}

export default NotesService;
